//
// JDom.js
//

class JDom {
    constructor(data) {
        this._data = data?.JTurn?.JDom ?? {};
    }

    innerHtml(value) {
        this._currentElement.innerHTML = decodeEntity(value);
    }

    innerText(value) {
        this._currentElement.innerText = decodeEntity(value);
    }

    removeHtml() {
        this._currentElement.remove();
    }

    prependChild(data) {
        for (let node of data) {
            if (typeof node == 'string') {
                node = decodeEntity(node);

                if (node.substring(0, 4) == '<tr ') {
                    node = parseHTML('<table>' + node + '</table>')[0];
                    node = node.querySelector('tbody > *');
                } else {
                    node = parseHTML(node)[0];
                }
            }

            this._currentElement.prepend(node);
        }
    }

    appendChild(data) {
        for (let node of data) {
            if (typeof node == 'string') {
                node = decodeEntity(node);

                if (node.substring(0, 4) == '<tr ') {
                    node = parseHTML('<table>' + node + '</table>')[0];
                    node = node.querySelector('tbody > *');
                } else {
                    node = parseHTML(node)[0];
                }
            }

            this._currentElement.appendChild(node);
        }
    }

    setAttribute(data) {
        for (const prop in data) {
            if (prop.substring(0, 5) == 'data-') {
                this._currentElement.setAttribute(prop, data[prop]);
            } else {
                eval(`this._currentElement.${prop} = data[prop];`);
            }
        }
    }

    removeAttribute(data) {
        for (const prop in data) {
            this._currentElement.removeAttribute(prop, data[prop]);
        }
    }

    addClass(data) {
        for (const prop in data) {
            this._currentElement.classList.add(data[prop]);
        }
    }

    removeClass(data) {
        for (const prop in data) {
            this._currentElement.classList.remove(data[prop]);
        }
    }

    modalHide() {
        const modal = Modal.getInstance(this._currentElement);

        if (modal._config.backdrop == 'static') {
            const close = this._currentElement.querySelector('[data-bs-dismiss="modal"]');
            const time = setInterval(function () {
                if (close.disabled) {
                    return;
                }

                close.click();
                clearInterval(time);
            }, 250);
        } else {
            modal.hide();
        }
    }

    run() {
        for (const selector in this._data) {
            for (const element of document.querySelectorAll(selector)) {
                this._currentElement = element;

                for (const action in this._data[selector]) {
                    eval(`this.${action}(this._data[selector][action])`);
                }
            }
        }
    }
}

// Make available globally
window.JDom = JDom;